import { isAdminModernExperienceEnabled } from '@thoughtspot/session-service';
import { ALL_ORGS_PREFIX, CUSTOMIZATION_SCREEN_ID_TO_SLUG, CUSTOMIZATION_SCREEN_IDS, LIVEBOARD_PREFIX, LIVEBOARD_SLUG_PREFIX, SLUG_TO_TAB_ID, TAB_ID_TO_SLUG, } from './admin-route-constants';
export function slugToTabId(slug) {
    if (SLUG_TO_TAB_ID[slug]) {
        return SLUG_TO_TAB_ID[slug];
    }
    if (slug.startsWith(LIVEBOARD_SLUG_PREFIX)) {
        return `${LIVEBOARD_PREFIX}${slug.slice(LIVEBOARD_SLUG_PREFIX.length)}`;
    }
    return slug;
}
export function tabIdToSlug(tabId) {
    if (isAdminModernExperienceEnabled() &&
        CUSTOMIZATION_SCREEN_IDS.has(tabId)) {
        return CUSTOMIZATION_SCREEN_ID_TO_SLUG[tabId] ?? 'customization';
    }
    if (TAB_ID_TO_SLUG[tabId]) {
        return TAB_ID_TO_SLUG[tabId];
    }
    if (tabId.startsWith(LIVEBOARD_PREFIX)) {
        return `${LIVEBOARD_SLUG_PREFIX}${tabId.slice(LIVEBOARD_PREFIX.length)}`;
    }
    return tabId;
}
export function parseAdminRoute() {
    const hash = window.location.hash || '';
    const match = hash.match(/#\/admin(?:\/(.*)|$)/);
    if (!match || !match[1]) {
        return { tabId: null, context: 'primary-org' };
    }
    const rest = match[1].split('?')[0];
    if (rest.startsWith(`${ALL_ORGS_PREFIX}/`)) {
        const slug = rest.slice(ALL_ORGS_PREFIX.length + 1) || null;
        return {
            tabId: slug ? slugToTabId(slug) : null,
            context: 'all-org',
        };
    }
    if (rest === ALL_ORGS_PREFIX) {
        return { tabId: null, context: 'all-org' };
    }
    return {
        tabId: rest ? slugToTabId(rest) : null,
        context: 'primary-org',
    };
}
export function buildAdminUrl(tabId, context) {
    const slug = tabIdToSlug(tabId);
    if (context === 'all-org') {
        return `#/admin/${ALL_ORGS_PREFIX}/${slug}`;
    }
    return `#/admin/${slug}`;
}
//# sourceMappingURL=admin-route-utils.js.map